/* eslint-disable camelcase */
import React, { useContext, useState } from 'react';
import { OnlineBookingContext } from '../..';
import Intro from '../Intro';
import Departure from './Departure';

const Departures = () => {
  const {
    departures: {
      list,
      price_tooltip_text,
      supplement_tooltip_text,
      contact_link,
      setCurrentNav,
    },
    handleNavChange,
    setSelectedDeparture,
    forwardNav,
  } = useContext(OnlineBookingContext);

  return (
    <div className="c-dates">
      <div className="c-dates__booking">
        <table className="c-dates__table">
          <thead>
            <tr>
              <th>Start date</th>
              <th>End date</th>
              <th>Price PP</th>
              <th>
                <span className="u-a11y">Flights included</span>
              </th>
              <th>Single supplement</th>
              <th>
                <span className="u-a11y">Book</span>
              </th>
            </tr>
          </thead>

          <tbody>
            {list.map((departure) => (
              <Departure
                key={`departure--${departure.id}`}
                payload={departure}
                price_tooltip_text={price_tooltip_text}
                supplement_tooltip_text={supplement_tooltip_text}
                contact_link={contact_link}
                forwardNav={forwardNav}
                setSelectedDeparture={setSelectedDeparture}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Departures;
